import { useEffect, useRef, useState } from "react";

import Footer from "../CommonComponents/Footer";
import { useStore } from "../../store";
import CustomList from "../CommonComponents/CustomList";
import BackHeader from "../CommonComponents/BackHeader";
import api from "../../api/apiClient";
import { endpoints } from "../../api/endpoints";
import { SongDataType, storeType } from "../../types";

export default function NewSongs() {
  const { store, updateStoreFunc } = useStore();

  const { scrollPos, page, hasMore, loading, data } = store.newSongs;

  const dataApi = useRef("");

  const fetchData = async () => {
    if (page === 1) updateStoreFunc("newSongs", "loading", true);

    const result: any = await api.get(
      endpoints.song.latestSong + `?current=${page}&limit=10`
    );
    dataApi.current =
      endpoints.song.latestSong + `?current=${page + 1}&limit=30`;
    if (page === 1) updateStoreFunc("newSongs", "loading", false);
    if (result.code === "200") {
      updateStoreFunc(null, null, null, (pre: storeType["store"]) => {
        const d: SongDataType = result.data;
        let arr: any;
        let o = { ...pre };
        let a: any = { ...o.newSongs.data };
        if (page > 1) {
          arr = [...a?.by, ...d?.by];
          a.by = arr;
          o.newSongs.data = a;
          return o;
        } else {
          a = d;
          o.newSongs.data = a;
          return o;
        }
      });
    } else {
      if (page > 1) {
        updateStoreFunc("newSongs", "hasMore", false);
      } else {
        updateStoreFunc("newSongs", "hasMore", false);
        updateStoreFunc("newSongs", "data", null);
      }
    }
  };

  const handleScroll = (event: any) => {
    const scrollTop = event.target.scrollTop;
    updateStoreFunc("newSongs", "scrollPos", scrollTop);
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  useEffect(() => {
    if (data?.by && data?.pagination) {
      if (data?.by?.length === data?.pagination?.total)
        updateStoreFunc("newSongs", "hasMore", false);
    }
  }, [data]);

  useEffect(() => {
    return () => {
      if (window.location.pathname === "/home") {
        updateStoreFunc("newSongs", "data", null);
        updateStoreFunc("newSongs", "hasMore", true);
        updateStoreFunc("newSongs", "page", 1);
      }
    };
  }, []);

  const handleFetchMore = () => {
    updateStoreFunc("newSongs", "page", page + 1);
  };

  return (
    <div>
      <BackHeader />

      <div style={{ padding: "0 15px" }}>
        <CustomList
          data={data}
          type={"Song"}
          showFavorite
          loading={loading}
          handleFetchMore={handleFetchMore}
          hasMore={hasMore}
          scrollHeight={store.screenHeight - 60}
          dataApi={dataApi.current}
          handleScroll={handleScroll}
          scrollPos={scrollPos}
        />
      </div>
      <Footer />
    </div>
  );
}
